import { render, staticRenderFns } from "./SportRecord.vue?vue&type=template&id=1c4e1fbc&scoped=true"
import script from "./SportRecord.vue?vue&type=script&lang=js"
export * from "./SportRecord.vue?vue&type=script&lang=js"
import style0 from "./SportRecord.vue?vue&type=style&index=0&id=1c4e1fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4e1fbc",
  null
  
)

export default component.exports